<template>
  <v-app>
    <v-layout>
      <client-only>
        <v-container
          v-if="showEvent"
          fluid
          class="restrict-width event-details-screen no-padding"
        >
          <v-row no-gutters>
            <v-col v-if="config.eventDescription" cols="12">
              <b-image-with-blurred-background
                class="event__banner"
                :image-src="mainImageUri"
                max-height="616px"
              >
              </b-image-with-blurred-background>
            </v-col>
          </v-row>
          <v-row class="px-5 mx-0">
            <v-col cols="12" class="px-0" style="overflow-wrap: break-word">
              <event-info-preview
                v-model="currentTab"
                :event="event"
                :organizer="organizer"
                :venue="venue"
                :tabs="tabs"
                :selected-occurrence="selectedOccurrence"
                :selected-timeslot="selectedTimeslot"
                @tabClicked="openWarningDialog"
              >
                <template #name>
                  <v-row class="row-10 event-detail pa-0 px-md-12 mx-md-12">
                    <v-col
                      v-if="!isMobile"
                      cols="1"
                      sm="4"
                      md="3"
                      class="py-0"
                    ></v-col>
                    <v-col cols="10" sm="6" class="pt-0">
                      <p
                        class="description-text textPrimary-base--text"
                        v-html="$sanitize(event.description)"
                      ></p>
                      <v-btn
                        v-if="$showTickets && !cartDisabled"
                        class="sector-map-btn mt-3"
                        @click="currentTab = tabName.Tickets"
                        >{{ $t('event.buyTickets') }}</v-btn
                      >
                    </v-col>
                  </v-row>
                </template>
                <template #tickets>
                  <v-window v-model="stepTickets">
                    <v-window-item
                      v-if="showDateTimePicker"
                      :class="{
                        'pt-12 mt-12':
                          config.showHeader && !config.eventDescription
                      }"
                    >
                      <v-row
                        v-if="event.occurrence.length > 1"
                        no-gutters
                        align="end"
                        class="pa-0 px-md-12 mx-md-12 pb-4 d-flex justify-end preferred-date"
                      >
                        <span class="p-float-label">
                          <PCalendar
                            id="preferredDate"
                            v-model="selectedDateRange"
                            class="full-width"
                            show-icon
                            date-format="dd/mm/yy"
                            selection-mode="range"
                            :manual-input="false"
                            show-button-bar
                          />
                          <label for="preferredDate">{{
                            $t('fields.preferredDate')
                          }}</label>
                        </span>
                      </v-row>
                      <v-row no-gutters class="px-md-12 mx-md-12 pb-4">
                        <v-col cols="12">
                          <date-list
                            v-if="filteredDates?.length > 0"
                            :event="event"
                            :occurrences="filteredDates"
                            @selectOccurrence="selectOccurrence"
                          >
                          </date-list>
                          <div
                            v-else
                            class="MOBILE_h18_Regular no-occurrences-message"
                          >
                            {{ $t('event.noOccurrences') }}
                          </div>
                        </v-col>
                      </v-row>
                    </v-window-item>
                    <v-window-item
                      :class="{
                        'pt-12 mt-12':
                          config.showHeader && !config.eventDescription
                      }"
                    >
                      <v-row
                        v-if="showDateTimePicker && stepTickets > 0"
                        class="row-10 ticket-selection-layout pb-4 px-md-12 mx-md-12"
                        no-gutters
                      >
                        <div class="d-flex align-center">
                          <IconArrowBack
                            color="lighten2"
                            width="18"
                            height="18"
                          />
                          <h3
                            class="ml-2 mb-0 font-weight-bold text-uppercase back-text cursor-pointer"
                            @click="goBackToOccurrences"
                          >
                            {{
                              selectedTimeslot
                                ? $t('sideMenu.timeslots')
                                : $t('sideMenu.occurrences')
                            }}
                          </h3>
                        </div>
                      </v-row>
                      <v-row
                        no-gutters
                        class="row-10 ticket-selection-layout pa-0 px-md-12 mx-md-12"
                      >
                        <v-col cols="10" lg="6">
                          <v-row
                            v-if="hasSectors && event.sectorsMapImageUri"
                            no-gutters
                          >
                            <v-col>
                              <v-btn
                                class="sector-map-btn"
                                depressed
                                @click="showSectorMap()"
                                >{{ $t('event.sectorMap') }}</v-btn
                              >
                            </v-col>
                          </v-row>
                          <v-row v-if="hasSectors">
                            <v-col
                              class="d-flex justify-start align-start pa-0 ml-4 mb-4"
                            >
                              <BChip
                                :chips="preparedSectors"
                                @click="selectSector"
                              ></BChip>
                            </v-col>
                          </v-row>
                          <div class="chart-container">
                            <div id="chart" class="mx-0 mx-md-6"></div>
                            <div v-if="showSeatsOverlay" class="chart-overlay">
                              <v-btn
                                class="confirm-button mb-0"
                                depressed
                                height="3.5rem"
                                @click="showSeatsOverlay = false"
                                >{{ $t('buyTickets.pickSeat') }}</v-btn
                              >
                            </div>
                          </div>
                          <v-row
                            v-if="!isSeatedEvent && eventLoaded"
                            no-gutters
                            class="mr-3"
                          >
                            <ticket-price-list-mobile
                              v-if="isMobile"
                              :ticket-config="preparedTicketConfigs()"
                              :event-status="event.status"
                              :ticket-discounts="event.ticketDiscount"
                              :owned-tickets="ownedTickets"
                              :selected-tickets="selectedTickets"
                              :selected-sector="event.selectedSector"
                              :selected-timeslot="selectedTimeslot"
                              :selected-occurrence="selectedOccurrence"
                              @remove="removeTicket"
                              @add="addTicket"
                              @openLogin="openLogin"
                            />
                            <ticket-price-list
                              v-else
                              :key="priceListKey"
                              :event-status="event.status"
                              :ticket-config="preparedTicketConfigs()"
                              :ticket-discounts="event.ticketDiscount"
                              :selected-tickets="selectedTickets"
                              :selected-timeslot="selectedTimeslot"
                              :owned-tickets="ownedTickets"
                              @add="addTicket"
                              @openLogin="openLogin"
                            />
                          </v-row>
                        </v-col>
                        <v-col v-if="!isSmallDevice" cols="4">
                          <ticket-price-preview
                            :ticket-config="event.ticketConfig"
                            :tickets="selectedTickets"
                            :timezone-name="event.timezoneName"
                            :currency="currency"
                            :selection-valid="selectionValid"
                            :discount-code-value="discountCodeValue"
                            @submit="showDialog"
                            @remove="removeTicketPreview"
                          />
                        </v-col>
                      </v-row>
                    </v-window-item>
                  </v-window>
                </template>

                <template #secondary>
                  <v-row no-gutters class="row-10 pa-0 px-md-12 mx-md-12">
                    <v-col cols="10" lg="6">
                      <ticket-price-list-mobile-s-m
                        v-if="isMobile"
                        :ticket-config="event.ticketConfig"
                        :tickets="ticketsSM"
                        @add="addTicketSM"
                      />
                      <v-data-table
                        v-else
                        :style="{ width: !isSmallDevice ? '95%' : '100%' }"
                        :headers="headers"
                        :items="ticketsSM"
                        :items-per-page="ticketsSM.length"
                        sort-by="price"
                        :no-data-text="$t('tickets.secondaryMarket.noTickets')"
                        :loading="loading"
                        :loading-text="$t('ticketConfigTable.loadingText')"
                      >
                        <!-- eslint-disable-next-line -->
                        <template #item.name="{ value }">
                          <span class="item-styling">
                            {{ value }}
                          </span>
                        </template>
                        <!-- eslint-disable-next-line -->
                        <template #item.actions="{ item }">
                          <v-btn
                            v-if="showSecondaryMarket && !cartDisabled"
                            class="sector-map-btn"
                            @click="addTicketSM(item)"
                          >
                            {{ $t('buyTickets.add') }}
                          </v-btn>
                        </template>
                        <!-- eslint-disable-next-line -->
                        <template #item.price="{ item, value }">
                          <span> {{ value }} {{ item.currency }} </span>
                        </template>
                      </v-data-table>
                    </v-col>
                    <v-col v-if="!isSmallDevice" cols="4">
                      <ticket-price-preview
                        :ticket-config="event.ticketConfig"
                        :tickets="selectedTicketsSM"
                        :currency="currency"
                        :selection-valid="selectionValid"
                        market="secondary"
                        @submit="showDialogSM()"
                        @remove="removeTicketPreviewSM"
                      />
                    </v-col>
                    <v-bottom-sheet
                      v-if="isSmallDevice && currentTab === tabName.Secondary"
                      ref="secondaryCart"
                      v-model="openSecondaryCart"
                      no-click-animation
                      internal-activator
                      hide-overlay
                      scrollable
                      persistent
                    >
                      <ticket-price-preview
                        :ticket-config="event.ticketConfig"
                        :tickets="selectedTicketsSM"
                        :currency="currency"
                        :selection-valid="selectionValid"
                        market="secondary"
                        @submit="showDialogSM()"
                        @remove="removeTicketPreviewSM"
                      />
                    </v-bottom-sheet>
                  </v-row>
                </template>
              </event-info-preview>
            </v-col>
          </v-row>
          <v-dialog
            v-model="errorDialog"
            max-width="36.375rem"
            overlay-opacity="0.8"
            overlay-color="backgroundPrimary"
            persistent
          >
            <v-card class="pa-4 pa-md-8 pa-xl-10">
              <v-row>
                <h1>{{ $t('cart.warningDialogHeader') }}</h1>
                <p
                  v-if="currentTab === tabName.Secondary"
                  class="primary-text-color"
                >
                  {{ $t('cart.dialogPrimaryToSecondary') }}
                </p>
                <p v-else class="primary-text-color">
                  {{ $t('cart.dialogSecondaryToPrimary') }}
                </p>
              </v-row>
              <v-row justify="end">
                <v-btn
                  class="primary-text-color ml-3 mb-2"
                  outlined
                  @click="goToPreviousTab"
                >
                  {{ $t('cart.dialogGoBack') }}
                </v-btn>
                <v-btn
                  class="text-primary ml-3"
                  @click="
                    currentTab === tabName.Secondary
                      ? clearCartAndCloseDialog(tabName.Tickets)
                      : clearCartAndCloseDialog(tabName.Secondary)
                  "
                >
                  {{ $t('cart.dialogContinue') }}
                </v-btn>
              </v-row>
            </v-card>
          </v-dialog>
          <v-dialog
            v-model="sectorMap"
            max-width="80%"
            width="unset"
            overlay-opacity="0.7"
            overlay-color="backgroundPrimary"
          >
            <v-card class="pa-2 pa-md-2 pa-xl-2">
              <v-img
                contain
                :src="event.sectorsMapImageUri"
                :lazy-src="require('static/1024x576.png')"
                max-height="100%"
              >
                <template #placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-card>
          </v-dialog>
          <!-- Modal used to select ticket format or login-->
          <v-dialog
            v-model="dialog"
            content-class="format-dialog"
            :persistent="false"
            overlay-opacity="0.8"
            overlay-color="backgroundPrimary"
          >
            <v-card class="dialog-card slider-background">
              <div class="format-container">
                <h1 class="center-text">{{ $t('cart.chooseFormat') }}</h1>
                <v-row class="format-buttons-container">
                  <v-col v-if="isFormatSupported('secure')">
                    <div
                      :class="{
                        'format-button': true,
                        active: format === formats.SECURE,
                        center: true
                      }"
                      data-cy="secureTicketFormatButton"
                      @click="setTicketFormat(formats.SECURE)"
                    >
                      <v-img
                        contain
                        max-height="60%"
                        max-width="60%"
                        :src="require('assets/img/secure-tickets.png')"
                      ></v-img>
                    </div>
                    <p class="font-weight-bold center-text">
                      {{ $t('cart.formatSecureTitle') }}
                    </p>
                    <p class="center-text">{{ $t('cart.formatSecureInfo') }}</p>
                  </v-col>
                  <v-col v-if="isFormatSupported('pdf')">
                    <div
                      :class="{
                        'format-button': true,
                        active: format === formats.PDF,
                        center: true
                      }"
                      data-cy="pdfTicketFormatButton"
                      @click="setTicketFormat(formats.PDF)"
                    >
                      <v-img
                        contain
                        max-height="60%"
                        max-width="60%"
                        :src="require('assets/img/pdf-tickets.svg')"
                      ></v-img>
                    </div>
                    <p class="font-weight-bold center-text">
                      {{ $t('cart.formatPDFTitle') }}
                    </p>
                    <p class="center-text">{{ $t('cart.formatPDFInfo') }}</p>
                  </v-col>
                </v-row>
                <div class="button-container">
                  <v-btn
                    :disabled="format === null"
                    class="confirm-button"
                    block
                    depressed
                    data-cy="confirmFormatButton"
                    height="3.5rem"
                    @click.stop="checkUserType()"
                    >{{ $t('actions.confirm') }}</v-btn
                  >
                </div>
                <!--                <div v-if="format === formats.SECURE">-->
                <!--                  <h1 class="text-center">{{ $t('cart.scanQRCode') }}</h1>-->
                <!--                  <v-row no-gutters>-->
                <!--                    <v-col></v-col>-->
                <!--                    <v-col cols="auto" class="qrcode-col">-->
                <!--                      <div class="qrcode-image-container">-->
                <!--                        <v-img-->
                <!--                          class="qrcode-image"-->
                <!--                          :src="qrcodeImage"-->
                <!--                          max-height="18.25rem"-->
                <!--                          max-width="18.25rem"-->
                <!--                          :lazy-src="require('static/1024x576.png')"-->
                <!--                        ></v-img>-->
                <!--                      </div>-->
                <!--                      <p class="font-weight-bold">-->
                <!--                        {{ $t('cart.walletConfirmTitle') }}-->
                <!--                      </p>-->
                <!--                      <p>{{ $t('cart.walletConfirmInfo') }}</p>-->
                <!--                      <div class="play-button-container">-->
                <!--                        <a-->
                <!--                          :href="$whitelabel.links.playStoreApp"-->
                <!--                          ><v-img-->
                <!--                            width="12.75rem"-->
                <!--                            alt="Get it on Google Play"-->
                <!--                            :src="require('~/assets/img/en_google_play.png')"-->
                <!--                        /></a>-->
                <!--                      </div>-->
                <!--                    </v-col>-->
                <!--                    <v-col></v-col>-->
                <!--                  </v-row>-->
                <!--                </div>-->
                <client-only>
                  <transition name="fade">
                    <BAuth
                      v-if="getAuthDialog"
                      @close="closeAuthDialog"
                    ></BAuth>
                  </transition>
                </client-only>
              </div>
            </v-card>
          </v-dialog>
          <transition name="slide" appear>
            <div
              v-if="isSmallDevice && currentTab === tabName.Tickets && openCart"
              class="cart-footer"
            >
              <div class="cart-footer__details">
                <div class="MOBILE_h16_Semibold">
                  {{ $t('mobileCart.total1') }} {{ total }} {{ currency }}
                </div>
                <div class="MOBILE_h13_Semibold">
                  {{ $t('mobileCart.tickets') }} {{ numberOfTickets }}
                </div>
              </div>
              <PButton
                class="cart-footer__button"
                :label="$t('mobileCart.cart')"
                @click="openMobileCart"
              />
            </div>
          </transition>
        </v-container>
        <ValidationObserver ref="observer" slim>
          <BActionsModal
            v-if="!isMobile"
            :show-modal="donationDialog"
            :title="$t('ticketDonation.header')"
            :cancel-text="$t('actions.cancel')"
            :confirm-text="$t('actions.add')"
            class="donation-dialog"
            data-cy="donationModal"
            @close="showDonationDialog(false)"
            @confirm="addTicket(donationTicket)"
          >
            <template #content>
              <div v-if="donationDialog" class="donation-dialog__content">
                <div class="MOBILE_h16_Regular donation-dialog__content--text">
                  <span
                    class="MOBILE_h16_Bold donation-dialog__content--text--bold"
                  >
                    {{ donationTicket.ticket.name }}
                  </span>
                  <span>{{ $t('ticketDonation.text1') }}</span>
                  <span
                    class="MOBILE_h16_Bold donation-dialog__content--text--bold"
                  >
                    {{ donationTicket.ticket.faceValue }}
                    {{ donationTicket.ticket.currency }}
                  </span>
                  <span>{{ $t('ticketDonation.text1.perTicket') }}</span>
                  <div>{{ $t('ticketDonation.text2') }}</div>
                </div>
                <ValidationProvider
                  v-slot="{ errors, validate }"
                  name="donationAmount"
                  :rules="`required|max_value:${maxDonationAmount}|min_donation:${minDonationAmount},${currency}`"
                >
                  <PInputNumber
                    v-model="donationAmount"
                    :placeholder="$t('ticketDonation.placeholder') + ' *'"
                    mode="decimal"
                    :min-fraction-digits="2"
                    :use-grouping="false"
                    :max="maxDonationAmount"
                    :class="{ 'p-invalid': errors.length }"
                    data-cy="donationAmountInput"
                    @input="validate"
                  />
                  <div
                    class="MOBILE_h12_Regular donation-dialog__content--error"
                  >
                    {{ errors[0] }}
                  </div>
                </ValidationProvider>
              </div>
            </template>
          </BActionsModal>
          <transition name="fade">
            <div v-if="isMobile && donationDialog" class="mobile-dialog">
              <div class="MOBILE_h24_Semibold mobile-dialog__header">
                {{ $t('ticketDonation.header') }}
              </div>
              <div class="MOBILE_h16_Regular mobile-dialog__content">
                <span class="MOBILE_h16_Bold mobile-dialog__content--text">
                  {{ donationTicket.ticket.name }}
                </span>
                <span>{{ $t('ticketDonation.text1') }}</span>
                <span class="MOBILE_h16_Bold mobile-dialog__content--text">
                  {{ donationTicket.ticket.faceValue }}
                  {{ donationTicket.ticket.currency }}.
                </span>
                <span>{{ $t('ticketDonation.text1.perTicket') }}</span>
                <div>{{ $t('ticketDonation.text2') }}</div>
              </div>
              <ValidationProvider
                v-slot="{ errors, validate }"
                name="donationAmount"
                :rules="`required|max_value:${maxDonationAmount}|min_donation:${minDonationAmount},${currency}`"
              >
                <PInputNumber
                  v-model="donationAmount"
                  :placeholder="$t('ticketDonation.placeholder') + ' *'"
                  mode="decimal"
                  :min-fraction-digits="2"
                  :use-grouping="false"
                  :max="maxDonationAmount"
                  :class="{ 'p-invalid': errors.length > 0 }"
                  @input="validate"
                />
                <div class="MOBILE_h12_Regular donation-dialog__content--error">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
              <div class="mobile-dialog__footer">
                <PButton
                  class="p-button-outlined"
                  :label="$t('actions.cancel')"
                  @click.native="showDonationDialog(false)"
                />
                <PButton
                  :label="$t('actions.add')"
                  @click.native="addTicket(donationTicket)"
                />
              </div>
            </div>
          </transition>
        </ValidationObserver>
        <div
          v-if="config.startDate && !hasFilteredEvents"
          class="px-0 px-sm-12 pb-8 pt-12 mt-7 MOBILE_h16_Medium event-details-screen"
        >
          {{ $t('ticket.noAvailableTickets') }}
        </div>
        <transition name="fade">
          <div v-if="mobileCartVisible" class="mobile-cart">
            <BMobileCart
              :tickets="selectedTickets"
              :total="total"
              :currency="currency"
              :selection-valid="selectionValid"
              :discount-code-value="discountCodeValue"
              @close="closeMobileCart"
              @empty="clearMobileCart"
              @remove="removeFromMobileCart"
              @submit="submitOrder"
            />
          </div>
        </transition>
      </client-only>
    </v-layout>
  </v-app>
</template>

<script>
import moment from 'moment-timezone';
import { setOptions, bootstrap } from 'vue-gtag';
import { uuid } from 'uuidv4';
import { mapGetters } from 'vuex';
import PButton from 'primevue/button';
import PInputNumber from 'primevue/inputnumber';
import PCalendar from 'primevue/calendar';
import { JwtCredentials } from '@bam/sdk';

import TicketPriceListMobile from '~/components/Ticket/TicketPriceListMobile';
import TicketPriceListMobileSM from '~/components/Ticket/TicketPriceListMobileSM';
import BChip from '~/components/general/BChip.vue';
import BMobileCart from '~/components/general/BMobileCart.vue';
import DateList from '~/components/Event/DateList';
import IconArrowBack from '~/components/general/icons/IconArrowBack.vue';
import BImageWithBlurredBackground from '~/components/general/BImageWithBlurredBackground';
import {
  TICKET_FORMATS,
  EVENT_TYPES,
  KYC_LEVELS,
  PAYMENT_TYPES,
  calculatePriceRange,
  errorMessage,
  sortEvents,
  getTimezoneFromName,
  sortByDisplayOrder,
  clone
} from '~/utils/utils';
import { applyDiscount } from '~/utils/pricing';
import { isValidHttpUrl } from '~/utils/url';
import {
  mapToLocationJsonLd,
  mapToOrganizerJsonLd,
  mapToEventJsonLd
} from '~/utils/json-ld';
import TicketPricePreview from '~/components/Ticket/TicketPricePreview';
import TicketPriceList from '~/components/Ticket/TicketPriceList';
import EventInfoPreview from '~/components/Event/EventInfoPreview';
import BAuth from '~/components/general/Auth/BAuth';
import BActionsModal from '~/components/general/BActionsModal.vue';
import {
  getMetaAdvancedMatchingData,
  toInitiateCheckoutEvent,
  toOccurrenceClickEvent
} from '~/utils/facebook';
import { ConditionalTicketValidator } from '~/utils/order/conditionals';
import { isSecondaryMarketUsed } from '~/utils/event/tickets';

export default {
  name: 'BuyTickets',
  components: {
    TicketPriceListMobile,
    DateList,
    TicketPriceList,
    TicketPricePreview,
    TicketPriceListMobileSM,
    EventInfoPreview,
    BChip,
    BAuth,
    PButton,
    PInputNumber,
    BMobileCart,
    BActionsModal,
    IconArrowBack,
    BImageWithBlurredBackground,
    PCalendar
  },
  layout: 'default_v2',
  async asyncData({ params, $bamApi, query }) {
    try {
      $bamApi.tenant = params.tenant;
      let eventInfo;
      if (query.acc_token) {
        eventInfo = await $bamApi.event.getPrivateEvent({
          id: params.id,
          access_token: query.acc_token
        });
      } else {
        eventInfo = await $bamApi.event.getEvent({ id: params.id });
      }
      return { eventInfo };
    } catch (error) {
      console.log(error);
    }

    return { eventInfo: {} };
  },
  data() {
    return {
      PAYMENT_TYPES,
      donationDialog: false,
      donationTicket: null,
      donationAmount: null,
      minDonationAmount: 2, // set this to the min donation amount (2 is because of the minimum payment amount)
      maxDonationAmount: 100000, // set this to the max donation amount
      mobileCartVisible: false,
      eventTypes: EVENT_TYPES,
      tabName: {
        Tickets: 0,
        EventInfo: 1,
        Secondary: 2
      },
      loading: true,
      currentTab: 0,
      event: null,
      originalEventData: null,
      discountCode: '',
      offers: null,
      showSeatsOverlay: false,
      seatsioEventId: null,
      eventLoaded: false,
      tab: 0,
      stepTickets: null,
      organizer: null,
      tickets: [],
      selectedTickets: [],
      selectedTicketsSM: [],
      ticketsSM: [],
      errorDialog: false,
      dialog: false,
      qrcodeImage: '',
      format: null,
      formats: TICKET_FORMATS,
      selectedTimeslot: null,
      selectedOccurrence: null,
      selectedDateRange: null,
      imageScale: 100,
      hideBottomText: false,
      allowExtendHeader: false,
      innerHeight: 0,
      sectorMap: false,
      datePickerClicks: 0,
      preparedSectors: [],
      headers: [
        {
          text: this.$t('ticket.ticketNameLabel').toUpperCase(),
          value: 'name',
          width: '50%',
          class: 'header-styling'
        },
        {
          text: this.$t('ticket.ticketSeatLabel').toUpperCase(),
          value: 'seat',
          class: 'header-styling'
        },
        {
          text: this.$t('ticket.ticketPriceLabel').toUpperCase(),
          value: 'price',
          class: 'header-styling'
        },
        {
          value: 'actions',
          sortable: false,
          align: 'right',
          class: 'header-styling'
        }
      ],
      isSMCart: false,
      config: {
        eventDescription: true,
        startDate: null,
        eventFoundByDate: false,
        showHeader: true
      },
      openCart: false,
      openSecondaryCart: false,
      ownedTickets: [],
      tenant: this.$route.params.tenant,
      seatSelectionValid: false,
      validator: new ConditionalTicketValidator(),
      eventId: this.$route.params.id,
      ignoreNextDeselection: false,
      orderExists: false,
      discountCodeValue: null
    };
  },
  async fetch() {
    try {
      this.$store.commit('app/setLoading', true);
      await this.getEvent();
      this.redirectIfNeeded(this.event);
      await this.getVenue();
      await this.getOrganizer();
      this.$nuxt.$emit('organizerFetched', this.organizer);
      // The tenant needs to be set or the fetchOwnedTickets will fail on the TH env
      this.$bamApi.tenant = this.tenant;
      if (this.showSecondaryMarket) {
        await this.getSecondaryTickets();
      }
      if (this.$auth.loggedIn) {
        await this.fetchOwnedTickets();
      }
      this.setupMetaPixel();
      this.setupGtag();
      this.handleOccurrenceLink();
    } catch (e) {
      this.$notifier.showMessage({
        content: errorMessage(e, this.$t('errors.fetchEvent')),
        type: 'error'
      });
    } finally {
      this.$store.commit('app/setLoading', false);
    }
  },
  fetchOnServer: false,
  head() {
    return {
      title: this.pageTitle,
      meta: [
        { hid: 'og:title', property: 'og:title', content: this.eventInfo.name },
        {
          hid: 'og:site_name',
          property: 'og:site_name',
          content: this.pageTitle
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: this.mainImageUriPreview
        },
        {
          hid: 'og:image:url',
          property: 'og:image:url',
          content: this.mainImageUriPreview
        },
        {
          hid: 'og:image:type',
          property: 'og:image:type',
          content: 'image/webp'
        },
        {
          hid: 'og:image:secure_url',
          property: 'og:image:secure_url',
          content: this.mainImageUriPreview
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.removeHtmlTags(this.eventInfo?.description)
        },
        {
          hid: 'twitter:card',
          property: 'twitter:card',
          content: 'summary'
        },
        {
          hid: 'twitter:title',
          property: 'twitter:title',
          content: this.eventInfo?.name
        },
        {
          hid: 'twitter:description',
          property: 'twitter:description',
          content: this.eventInfo?.description
        },
        {
          hid: 'twitter:image',
          property: 'twitter:image',
          content: this.mainImageUriPreview
        }
      ]
    };
  },
  computed: {
    ...mapGetters('orders', ['getReducedOrder']),
    ...mapGetters('app', ['getLoading', 'getAuthDialog']),
    mainImageUriPreview() {
      return (
        this.eventInfo?.mainImageUri?.replace('16x9', '4x3') ||
        require('assets/img/event_placeholder.webp').replace('16x9', '4x3')
      );
    },
    mainImageUri() {
      return (
        this.eventInfo.mainImageUri ||
        require('assets/img/event_placeholder.webp')
      );
    },
    showSecondaryMarket() {
      // The SM tab is displayed if the feature flag is active and there is a ticket configuration which uses it
      return this.$showSecondary && isSecondaryMarketUsed(this.event);
    },
    tabs() {
      // Tabs to be displayed
      const displayedTabs = [
        { label: this.$t('main.tabs.tickets'), name: 'tickets' },
        { label: this.$t('main.tabs.eventInfo'), name: 'name' }
      ];

      if (this.showSecondaryMarket) {
        displayedTabs.push({
          label: this.$t('main.secondaryMarket'),
          name: 'secondary'
        });
      }

      return displayedTabs;
    },
    /**
     * This computed property calculates the total price of all selected tickets.
     *
     * @returns {string} The total price, formatted as a string. The number of decimal places
     * depends on whether the current currency is a cryptocurrency. For cryptocurrencies, the
     * total price is formatted with 8 decimal places. For other currencies, the total price
     * is formatted with 2 decimal places.
     */
    total() {
      const isCrypto = this.$whitelabel.supportedCryptoCurrencies.includes(
        this.currency?.toUpperCase()
      );
      const total = this.selectedTickets.reduce((sum, ticket) => {
        if (ticket.donationAmount) {
          return sum + parseFloat(ticket.donationAmount);
        } else {
          return sum + parseFloat(ticket.finalPrice);
        }
      }, 0);
      return total.toFixed(isCrypto ? 8 : 2);
    },
    numberOfTickets() {
      return this.selectedTickets.length;
    },
    currency() {
      if (this.event?.ticketConfig?.length !== 0) {
        return this.currentTab === this.tabName.Tickets
          ? this.event?.ticketConfig?.[0].currency
          : this.offers?.[0]?.currency;
      }
      return '';
    },
    pageTitle() {
      if (this.eventInfo.name) {
        return `${this.eventInfo.name} | ${this.$t('page.title')}`;
      }
      return this.$t('page.title');
    },
    isRecurring() {
      return this.event.type === this.eventTypes.RECURRING;
    },
    cartDisabled() {
      return moment(this.event?.endAt).isBefore(moment());
    },
    subcategory() {
      return this.event?.subcategory?.name;
    },
    hasSectors() {
      return this.event?.sector?.length > 0;
    },
    hasTimeslots() {
      return this.event?.timeslot?.length > 0;
    },
    priceListKey() {
      if (this.hasSectors) {
        return this.event.selectedSector?.id;
      }
      if (this.hasTimeslots) {
        return this.selectedTimeslot?.id;
      }
      return null;
    },
    showDateTimePicker() {
      return (
        this.event?.type === this.eventTypes.RECURRING ||
        this.event?.timeslot?.length > 0
      );
    },
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    isSmallDevice() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    venue() {
      if (this.event.type === EVENT_TYPES.RECURRING) {
        return this.selectedOccurrence?.venue;
      } else {
        return this.event?.venue;
      }
    },
    filteredDates() {
      // Find better solution (by Branimir)
      if (this.datePickerClicks > 1 && this.selectedDateRange?.length > 0) {
        return this.event?.occurrence?.filter((date) => {
          return moment(date.startAt).isBetween(
            moment(this.selectedDateRange[0]),
            moment(this.selectedDateRange[1]),
            'day',
            '[]'
          );
        });
      } else {
        return this.event?.occurrence;
      }
    },
    hasFilteredEvents() {
      return this.config.eventFoundByDate;
    },
    showEvent() {
      return (
        (this.event && !this.config.startDate) ||
        (this.config.startDate && this.hasFilteredEvents)
      );
    },
    selectionValid() {
      if (this.isSeatedEvent) {
        return this.seatSelectionValid;
      }
      return true;
    },
    isSeatedEvent() {
      if (this.isRecurring) {
        return this.selectedOccurrence?.chartKey;
      }
      return this.event.chartKey;
    },
    conditionalTicketingSatisfied() {
      // Validate if the order would be valid if we added a ticket of `ticketConfig` type
      // to the combination of tickets in cart and already owned tickets
      return (ticketConfig) => {
        if (!this.configIsConditional(ticketConfig)) {
          return true;
        }
        const canAddTicket = this.validator.canAddTicket(
          ticketConfig,
          this.ownedTickets,
          this.selectedTickets
        );
        return canAddTicket;
      };
    }
  },
  watch: {
    openCart() {
      this.$nextTick(() => {
        if (this.$refs.cart) {
          this.$refs.cart.showScroll();
        }
      });
    },
    getAuthDialog(newValue) {
      if (newValue && this.selectedTickets.length > 0) {
        this.openCart = true;
      }
    },
    format(newValue) {
      if (newValue === 'PDF') {
        this.$store.commit('app/setEnableGuestLogin', true);
      } else {
        this.$store.commit('app/setEnableGuestLogin', false);
      }
    },
    selectedDateRange() {
      this.datePickerClicks++;
    },
    /**
     * Controls mobile header collapse/expand
     * @param newValue
     * @param oldValue
     */
    hideBottomText(newValue, oldValue) {
      if (!newValue && newValue !== oldValue) {
        this.imageScale = 100;
      }
    },
    'organizer.workspaceKey'(newValue, oldValue) {
      if (newValue !== oldValue && this.isSeatedEvent) {
        this.$nextTick(function () {
          this.fetchSeats();
        });
      } else {
        this.eventLoaded = true;
      }
    },
    selectedTickets(newValue) {
      this.openCart = newValue.length > 0;
    },
    selectedTicketsSM(newValue) {
      if (newValue.length > 0) {
        this.openSecondaryCart = true;
      } else {
        this.openSecondaryCart = false;
      }
    },
    'config.startDate'(newValue) {
      if (newValue) {
        const foundOccurrence = this.event?.occurrence?.find((occurrence) => {
          return moment(occurrence.startAt).isSame(moment(newValue), 'day');
        });
        if (foundOccurrence) {
          this.selectOccurrence({ occurrence: foundOccurrence });
          this.config.eventFoundByDate = true;
        } else {
          this.config.eventFoundByDate = false;
        }
      }
    }
  },
  created() {
    this.$nuxt.$on('onLogin', this.onLogin);
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    const description = urlParams.get('description');
    const header = urlParams.get('header');
    const startDate = urlParams.get('start_date');
    const discountCode = urlParams.get('discountCode');
    if (description && description === 'false') {
      this.config.eventDescription = false;
    }
    if (header === 'false') {
      this.config.showHeader = false;
    }
    if (startDate) {
      this.config.startDate = startDate;
    }
    if (discountCode) {
      this.discountCodeValue = discountCode;
    }
  },
  beforeDestroy() {
    this.$nuxt.$off('onLogin');
    this.disableMetaPixel();
    this.disableGtag();
    if (this.seatingChart?.iframe) {
      this.seatingChart.destroy();
    }
  },
  /**
   * Builds JSONLD for Google web crawlers
   *
   */
  jsonld() {
    if (!this.event) {
      return null; // So that we don't have the tag if the event is not present
    }
    const location = mapToLocationJsonLd(this.venue);
    const organizer = mapToOrganizerJsonLd(this.organizer);
    const eventData = mapToEventJsonLd(
      this.event,
      this.$route.fullPath,
      location,
      organizer
    );
    return eventData;
  },
  methods: {
    handleOccurrenceLink() {
      const urlParams = new URLSearchParams(window.location.search);
      const occurrenceId = parseInt(urlParams.get('occurrence_id'));
      if (occurrenceId) {
        const foundOccurrence = this.event.occurrence.find(
          (occurrence) => occurrence.id === occurrenceId
        );
        if (foundOccurrence) {
          this.selectOccurrence({ occurrence: foundOccurrence });
        }
      }
    },
    // NOTE: id property of the returned object is id of the ticket config
    // id of the ticket itself is preserved in the ticketId property
    // TODO: consider renaming properties to be more intuitive and updating logic across page(s)
    adjustOrderTicketForCart(ticket) {
      return {
        ...ticket,
        discount: ticket.ticketDiscount[0],
        kycLevelId: ticket.ticketConfig.kycLevelId,
        id: ticket.ticketConfig.id,
        name: ticket.ticketConfig.name,
        pricingType: ticket.ticketConfig.pricingType,
        timeslotId: ticket.timeslot?.id,
        timeslotName: ticket.timeslot?.name,
        timeslotStartAt: ticket.timeslot?.startAt,
        timeslotEndAt: ticket.timeslot?.endAt,
        ticketId: ticket.id,
        donationAmount: this.isDonation(ticket.ticketConfig.pricingType)
          ? ticket.grossPrice
          : null
      };
    },
    populateCart(eventType) {
      if (eventType === this.eventTypes.SINGLE) {
        const reducedOrder = this.getReducedOrder(this.eventId);
        if (reducedOrder && reducedOrder.market === 'primary') {
          // We check if there are tickets in the cart with seats
          const ticketsHaveSeats = reducedOrder.tickets.some(
            (t) => t.seatId || t.seat?.id
          );
          if (ticketsHaveSeats) {
            // If there are tickets in the cart with seats, we clear the cart to prevent
            // tickets being added twice (since they're automatically added by addSeat method)
            this.selectedTickets.splice(0, this.selectedTickets.length);
          } else {
            this.selectedTickets = reducedOrder.tickets.map((ticket) => {
              return this.adjustOrderTicketForCart(ticket);
            });
          }
          this.orderExists = true;
        }
      }
    },
    adjustRecurringEventDates(event) {
      sortEvents(event.occurrence);
      const numberOfOccurrences = event.occurrence.length;
      if (numberOfOccurrences > 0) {
        event.startAt = event.occurrence[0].startAt;
        event.endAt = event.occurrence[numberOfOccurrences - 1].endAt;
      }
    },
    async assignVenuesToOccurrences(occurrences) {
      try {
        const venueIds = [
          ...new Set(occurrences.map((occurrence) => occurrence.venueId))
        ];
        const venues = await this.$bamApi.venue.getVenues({ ids: venueIds });
        const occurrencesWithVenues = occurrences.map((occurrence) => {
          const venue = venues.find(
            (venue) => Number(venue.id) === Number(occurrence.venueId)
          );
          occurrence.venue = venue;
          return occurrence;
        });
        return occurrencesWithVenues;
      } catch (e) {
        this.$notifier.showMessage({
          content: errorMessage(e, this.$t('errors.fetchVenue')),
          type: 'error'
        });
      }
    },
    configIsConditional(config) {
      return config?.dependsOn?.length > 0;
    },
    conditionalConfigText(config) {
      return config?.dependsOn?.map((tc) => tc?.name).join(', ');
    },
    setupMetaPixel() {
      if (this.organizer?.metaPixelId) {
        // Avoid duplicate pixel initialization
        if (this.$fb.options.pixelId !== this.organizer.metaPixelId) {
          this.$fb.setPixelId(this.organizer.metaPixelId);
        }
        if (this.$auth.loggedIn) {
          const userData = getMetaAdvancedMatchingData(this.$auth.user);
          this.$fb.setUserData(userData);
        }
        this.$fb.enable(); // This also sends a tracking event
      }
    },
    disableMetaPixel() {
      if (this.organizer?.metaPixelId) {
        this.$fb.disable();
      }
    },
    setupGtag() {
      if (this.organizer?.gtmId) {
        // Update the gtag ID with the organizer's ID
        setOptions({
          config: { id: this.organizer?.gtmId }
        });
        // initialize the GTAG library
        bootstrap().then((gtag) => {
          // Track some event afterwards?
        });
      }
    },
    disableGtag() {
      if (this.organizer?.gtmId) {
        this.$gtag.optOut();
      }
    },
    isDonation(type) {
      return type === this.PAYMENT_TYPES.DONATION;
    },
    showDonationDialog(donationDialogShown) {
      this.donationDialog = donationDialogShown;
      const seat = this.donationTicket?.seat;
      if (seat && !donationDialogShown && !this.donationAmount) {
        seat.deselect(seat.selectedTicketType);
      }
      if (this.donationDialog) {
        document.documentElement.style.overflow = 'hidden';
        document.body.scroll = 'no';
      } else {
        document.documentElement.style.overflow = 'scroll';
        document.body.scroll = 'yes';
      }
    },
    removeHtmlTags(description) {
      if (!description) {
        return;
      }
      const tagsToRemove =
        /<\/?(h1|h2|h3|br|hr|blockquote|s|u|i|b|code|ol|ul)[^>]*>/gi;
      return description
        .replace(/<p>/gi, '')
        .replace(/<\/p>/gi, '\n')
        .replace(tagsToRemove, '');
    },

    // Opens the mobile cart
    openMobileCart() {
      this.mobileCartVisible = true;
      document.documentElement.style.overflow = 'hidden';
      document.body.scroll = 'no';
    },

    // Closes the mobile cart
    closeMobileCart() {
      this.mobileCartVisible = false;
      document.documentElement.style.overflow = 'scroll';
      document.body.scroll = 'yes';
    },

    // Clears the mobile cart by clearing the ticket preview and closing the cart
    clearMobileCart() {
      this.clearTicketPreview();
      this.closeMobileCart();
    },

    /**
     * Removes a ticket from the mobile cart based on its ID
     * @param {string} id - The ID of the ticket to be removed
     */
    async removeFromMobileCart({ ticket, index }) {
      await this.removeTicketPreview({ ticket, index });
      if (this.selectedTickets.length === 0) {
        this.closeMobileCart();
      }
    },

    /**
     * Submits an order with a discount code, shows the dialog, and closes the mobile cart
     * @param {string} discountCode - The discount code to be applied to the order
     */
    submitOrder(discountCode) {
      this.showDialog(discountCode);
      this.closeMobileCart();
    },
    closeAuthDialog() {
      this.$store.commit('app/setAuthDialog', false);
      this.$store.commit('app/setEnableGuestLogin', false);
      document.body.style = '';
    },
    openLogin() {
      this.$store.commit('app/setAuthDialog', true);
      this.openCart = false;
      document.body.style = 'height: 100vh; overflow-y: hidden';
    },
    async onLogin() {
      this.$store.commit('app/setLoading', true);
      if (this.format) {
        if (this.selectedTickets.length !== 0) {
          await this.createOrder();
          if (this.selectedTickets.some((tc) => this.configIsConditional(tc))) {
            await this.fetchOwnedTickets();
          }
        }
        if (this.selectedTicketsSM.length !== 0) {
          await this.createSMOrder();
        }
      }
      this.$store.commit('app/setLoading', false);
    },
    preparedTicketConfigs() {
      if (this.hasSectors) {
        return this.event.selectedSector.ticketConfig
          .map((tc) => {
            return {
              ...this.event.ticketConfig.find((etc) => etc.id === tc.id)
            };
          })
          .filter((tc) => tc.visible);
      }
      return this.event.ticketConfig;
    },
    findDiscount(discountId) {
      return this.event.ticketDiscount?.find((td) => td.id === discountId);
    },
    findPreparedTicketConfig(ticketConfigId) {
      return this.event.ticketConfig.find((tc) => tc.id === ticketConfigId);
    },
    findOriginalTicketConfig(ticketConfigId) {
      return this.originalEventData.ticketConfig.find(
        (tc) => tc.id === ticketConfigId
      );
    },
    findTicketConfig(ticketConfigId, occurrenceId) {
      if (occurrenceId) {
        const occurrence = this.event.occurrence.find(
          (occurrence) => occurrence.id === occurrenceId
        );
        const occurrenceTicketConfig = occurrence.ticketConfig;
        return occurrenceTicketConfig.find((tc) => tc.id === ticketConfigId);
      }
      return (
        this.findPreparedTicketConfig(ticketConfigId) ??
        this.findOriginalTicketConfig(ticketConfigId)
      );
    },
    selectSector(sector) {
      this.event.selectedSector = this.event.sector.find((s) =>
        sector.includes(s.id)
      );
    },
    goBackToOccurrences() {
      if (this.selectedOccurrence.chartKey) {
        this.showSeatsOverlay = false;
        this.seatingChart.destroy();
      }
      this.selectedOccurrence = null;
      this.selectedTimeslot = null;
      this.stepTickets--;
    },
    openWarningDialog(tab) {
      switch (tab) {
        case 'tickets':
          this.errorDialog = this.selectedTicketsSM.length !== 0;
          break;
        case 'secondary':
          this.errorDialog = this.selectedTickets.length !== 0;
          break;
      }
    },
    goToPreviousTab() {
      if (this.currentTab === this.tabName.Tickets) {
        this.currentTab = this.tabName.Secondary;
      } else {
        this.currentTab = this.tabName.Tickets;
      }
      this.errorDialog = false;
    },
    clearCartAndCloseDialog(tab) {
      this.errorDialog = false;
      if (tab === this.tabName.Secondary) {
        this.ticketsSM = this.ticketsSM.concat(this.selectedTicketsSM);
        while (this.selectedTicketsSM.length > 0) {
          this.selectedTicketsSM.pop();
        }
      } else {
        this.clearTicketPreview();
      }
    },
    showSectorMap() {
      this.sectorMap = true;
    },
    isFormatSupported(format) {
      return this?.event?.ticketFormat?.find(
        (tf) => tf.name.toLowerCase() === format
      );
    },
    setTicketFormat(format) {
      switch (format) {
        case TICKET_FORMATS.SECURE:
          if (!this.event.ticketFormat.find((tf) => tf.name === 'secure'))
            return;
          break;
        case TICKET_FORMATS.PDF:
        case TICKET_FORMATS.PKPASS:
          if (
            !this.event.ticketFormat.find((tf) => tf.name === 'pdf') &&
            !this.event.ticketFormat.find((tf) => tf.name === 'pkpass')
          )
            return;
          break;
      }
      this.format = format;
    },
    selectOccurrence({ occurrence, timeslot }) {
      // TODO: improve this
      let ticketConfig = this.prepareTicketConfig(
        occurrence.ticketConfig,
        occurrence.type
      );
      if (timeslot) {
        ticketConfig = timeslot.ticketConfig.map((tc) => {
          return {
            ...occurrence.ticketConfig.find((otc) => otc.id === tc.id),
            ...tc
          };
        });
      }
      this.event = {
        ...this.event,
        ticketConfig: this.prepareTicketConfig(ticketConfig, this.event.type)
      };
      this.selectedOccurrence = occurrence;
      this.selectedTimeslot = timeslot;
      this.stepTickets++;
      if (this.selectedOccurrence.chartKey) {
        this.fetchSeats();
      }
      this.$fb.track(
        'ViewContent',
        toOccurrenceClickEvent(this.selectedOccurrence),
        { eventID: Date.now().toString() } // So that FB does think this is the same event as another click
      );
      this.redirectIfNeeded(occurrence); // If you also want to redirect on occurrence click
    },
    showDialog(discountCode) {
      this.discountCode = discountCode;
      this.dialog = true;
      if (this.isFormatSupported('secure') && this.isFormatSupported('pdf')) {
        this.format = null;
      } else if (this.isFormatSupported('secure')) {
        this.setTicketFormat(this.formats.SECURE);
      } else if (this.isFormatSupported('pdf')) {
        this.setTicketFormat(this.formats.PDF);
      }
    },
    showDialogSM() {
      this.format = this.formats.SECURE;
      if (!this.$auth.loggedIn) {
        this.dialog = null;
        this.openLogin();
      } else {
        this.buyTickets();
      }
    },
    closeDialog() {
      this.dialog = false;
    },
    fetchSeats() {
      if (this.organizer?.workspaceKey) {
        this.publicKey = this.organizer.workspaceKey;
        try {
          // if event has occurrences or timeslots, seatmap is rendered only after user selects occurrence/timeslot
          // otherwise, seatmap is loaded when page is rendered
          this.seatsioEventId =
            this.isRecurring || this.hasTimeslots
              ? String(this.selectedOccurrence.id)
              : String(this.event.id);
          this.renderSeatingChart();
          this.eventLoaded = true;
        } catch (e) {
          this.seatsioEventId = null;
          this.eventLoaded = true;
        }
      }
    },
    renderSeatingChart() {
      const ticketConfigs = this.isRecurring
        ? this.selectedOccurrence.ticketConfig
        : this.event.ticketConfig;

      const pricing = ticketConfigs.map((tc) => {
        const ticketTypes = [
          { name: this.$t('buyTickets.noDiscount') },
          ...tc.ticketDiscount // Add discounted options
        ];
        return {
          category: tc.name, // Their category is our ticket config
          ticketTypes: ticketTypes.map((discount) => {
            const price = applyDiscount(discount, tc.faceValue);
            return {
              ticketType: String(discount.id),
              label: discount.name,
              price
            };
          })
        };
      });

      const maxSelectedObjects = ticketConfigs.map((tc) => ({
        category: tc.name,
        quantity: Math.min(tc.ticketsPerUser, tc.availableTickets)
      }));
      const unavailableCategories = ticketConfigs
        .filter((tc) => tc.ended || !tc.started)
        .map((tc) => tc.name);

      this.$nextTick(() => {
        this.seatingChart = new window.seatsio.SeatingChart({
          divId: 'chart',
          publicKey: this.publicKey,
          event: this.seatsioEventId,
          session: 'continue',
          language: this.$i18n.locale,
          pricing,
          maxSelectedObjects,
          unavailableCategories,
          priceFormatter: (price) => {
            return price + ' ' + ticketConfigs[0].currency;
          },
          channels: ['NO_CHANNEL'],
          onObjectSelected: this.addSeat,
          onObjectDeselected: this.removeSeat,
          onChartRendered: () => {
            this.showSeatsOverlay = true;
          },
          onChartRenderingFailed: (chart) => {
            chart.destroy();
            this.seatsioEventId = null;
          },
          selectionValidators: [{ type: 'noOrphanSeats' }],
          onSelectionValid: () => {
            this.seatSelectionValid = true;
          },
          onSelectionInvalid: () => {
            this.seatSelectionValid = false;
            this.$notifier.showMessage({
              title: this.$t('seats.noOrphanError.title'),
              content: this.$t('seats.noOrphanError.content'),
              type: 'error'
            });
          }
        }).render();
      });
    },
    /**
     * Adds ticket from seat chart to selected seats and cart
     *
     * @param seat
     * @param ticketType
     */
    addSeat(seat, ticketType) {
      // this block of code handles the case when user cancels the order
      if (this.orderExists) {
        const order = this.getReducedOrder(this.eventId);
        // comparing tickets by ids is done to prevent adding same ticket from the order multiple times
        const foundTicket = order.tickets.find(
          (ticket) =>
            (ticket.ticketConfig.id === seat.category.key ||
              ticket.ticketConfig.name === seat.category.key) &&
            !this.selectedTickets.some((st) => st.ticketId === ticket.id)
        );
        if (foundTicket) {
          this.selectedTickets.push({
            ...this.adjustOrderTicketForCart(foundTicket),
            seat
          });
        }
        if (this.selectedTickets?.length === order.tickets?.length) {
          this.orderExists = false;
        }
        return;
      }

      // this block of code handles the case when there is no existing order for the user for the event
      // or when all the tickets from the canceled order have already been added to the cart and selected in the seatmap
      this.event.ticketConfig.forEach((tc) => {
        // Since the new behavior is a key = tc.name and the old one is key=tc.id
        if (tc.id === seat.category.key || tc.name === seat.category.key) {
          if (this.configIsConditional(tc) && !this.$auth.loggedIn) {
            this.ignoreNextDeselection = true;
            seat.deselect(seat.selectedTicketType);
            this.openLogin();
            return;
          }
          if (!this.conditionalTicketingSatisfied(tc)) {
            this.$notifier.showMessage({
              content: this.$t('conditional.error.message', {
                ticket: this.conditionalConfigText(tc)
              }),
              type: 'error'
            });
            // we have to set this because otherwise we would remove another ticket from the cart,
            // in the case of general admission tickets, since they all have the same id
            this.ignoreNextDeselection = true;
            seat.deselect(seat.selectedTicketType);
            return;
          }
          tc.discounts.forEach((discount) => {
            if (String(discount.id) === ticketType.ticketType) {
              if (this.isDonation(tc.pricingType) && !this.donationDialog) {
                this.donationAmount = null;
                this.donationTicket = { ticket: tc, discount, seat };
                this.showDonationDialog(true);
                return;
              }
              this.selectedTickets.push({
                ...tc,
                ...this.adjustTicketDataForCart(tc, discount, seat)
              });
            }
          });
        }
      });
    },
    /**
     * Removes ticket from seat chart selected seats and cart
     *
     * @param seat
     */
    removeSeat(seat) {
      // ignoreNextDeselection is set when we deselect an object in seats which wasn't added to the cart
      // this happens e.g. if conditional ticketing isn't satisfied
      if (this.ignoreNextDeselection) {
        this.ignoreNextDeselection = false;
        return;
      }
      const index = this.selectedTickets
        .map((x) => x.seat?.id)
        .indexOf(seat.id);
      if (index >= 0) {
        this.selectedTickets.splice(index, 1);
      }
    },
    // append data for ticket in cart in order to display additional details
    adjustTicketDataForCart(ticket, discount, seat) {
      const selectedTicket = {
        ...ticket
      };
      selectedTicket.sector = this.event.selectedSector;
      selectedTicket.finalPrice = this.isDonation(ticket.pricingType)
        ? this.donationAmount
        : discount?.finalPrice;
      selectedTicket.discount = discount?.id ? discount : undefined;
      selectedTicket.fees = discount?.fees;
      selectedTicket.seat = seat;
      if (this.isRecurring) {
        selectedTicket.occurrenceId = this.selectedOccurrence.id;
        selectedTicket.occurrenceName = this.selectedOccurrence.name;
        selectedTicket.occurrenceStartAt = this.selectedOccurrence.startAt;
        selectedTicket.occurrenceEndAt = this.selectedOccurrence.endAt;
      }
      if (this.selectedTimeslot?.id) {
        selectedTicket.timeslotId = this.selectedTimeslot.id;
        selectedTicket.timeslotName = this.selectedTimeslot.name;
        selectedTicket.timeslotStartAt = this.selectedTimeslot.startAt;
        selectedTicket.timeslotEndAt = this.selectedTimeslot.endAt;
      }
      return selectedTicket;
    },
    /**
     * Add ticket to cart
     *
     * @param seat
     */
    async addTicket({ ticket, discount, seat }) {
      const valid = await this.$refs.observer.validate();
      if (!valid) {
        this.$notifier.showMessage({
          content: this.$t('errors.fixForm'),
          type: 'error'
        });
        window.scrollTo(0, 0);
        return;
      }
      /**
       * This code block checks if the ticket pricing type is 'donation' and if
       * the donation dialog is not already open. If both conditions are met,
       * it sets the donation amount to the ticket's face value, assigns the
       * ticket and discount to the donationTicket object, and shows the donation
       * dialog. If the donationTicket object exists, it sets the final price of
       * the discount to the donation amount. Finally, it hides the donation dialog.
       */
      if (this.isDonation(ticket.pricingType) && !this.donationDialog) {
        this.donationAmount = null;
        this.donationTicket = { ticket, discount };
        this.showDonationDialog(true);
        return;
      }
      if (this.donationTicket) {
        ticket.donationAmount = this.donationAmount;
      }
      if (this.isMobile && this.donationDialog) {
        this.openMobileCart();
      }
      this.showDonationDialog(false);
      const selectedTicket = {
        ...ticket,
        ...this.adjustTicketDataForCart(ticket, discount, seat)
      };
      const foundTicketConfig = this.findTicketConfig(
        ticket.id,
        ticket.occurrenceId
      );
      foundTicketConfig.availableTickets--;
      foundTicketConfig.amountOfTicketInCart++;
      const foundDiscount = this.findDiscount(discount.id);
      if (foundDiscount?.availableTickets !== undefined) {
        foundDiscount.availableTickets--;
      }
      discount.selectedQuantity++;
      this.selectedTickets.push(selectedTicket);

      /**
       * Sets the value of donationTicket to null after adding the ticket
       * to the cart.
       */
      this.donationTicket = null;
    },
    addTicketSM(ticket) {
      this.selectedTicketsSM.push(ticket);
      this.ticketsSM = this.ticketsSM.filter((t) => t.id !== ticket.id);
    },
    /**
     * Removes ticket from cart. Called from ticket selection
     *
     * @param {ticket, discount}
     */
    removeTicket({ ticket, discount }) {
      ticket.sector = this.event.selectedSector;
      discount.selectedQuantity--;
      const foundTicketConfig = this.findTicketConfig(
        ticket.id,
        ticket.occurrenceId
      );
      foundTicketConfig.availableTickets++;
      foundTicketConfig.amountOfTicketInCart--;
      for (let i = 0; i < this.selectedTickets.length; i++) {
        const t = this.selectedTickets[i];
        // TODO: Simplify the following condition
        if (
          t?.sector?.id === ticket?.sector?.id &&
          (discount?.id
            ? t.discount?.id === discount.id
            : t.discount === undefined) &&
          t.id === ticket.id
        ) {
          this.selectedTickets.splice(i, 1);
          break;
        }
      }
      const foundDiscount = this.findDiscount(discount.id);
      if (foundDiscount?.availableTickets !== undefined) {
        foundDiscount.availableTickets++;
      }
    },
    async removeTicketPreview({ ticket, index }) {
      const foundTicketConfig = this.findTicketConfig(
        ticket.id,
        ticket.occurrenceId
      );
      foundTicketConfig.availableTickets++;
      foundTicketConfig.amountOfTicketInCart--;
      const seat = this.selectedTickets[index].seat;
      if (seat) {
        await seat.deselect(seat.selectedTicketType);
      } else {
        this.selectedTickets.splice(index, 1);
      }
      this.recalculateDiscountQuantity(ticket);
    },
    clearTicketPreview() {
      while (this.selectedTickets.length > 0) {
        const ticket = this.selectedTickets.shift();
        const foundTicketConfig = this.findTicketConfig(
          ticket.id,
          ticket.occurrenceId
        );
        foundTicketConfig.availableTickets++;
        foundTicketConfig.amountOfTicketInCart--;
        const seat = ticket.seat;
        if (seat) {
          seat.deselect(seat.selectedTicketType);
        }
        this.recalculateDiscountQuantity(ticket);
      }
    },
    recalculateDiscountQuantity(ticket) {
      let foundDiscount;
      for (const ticketConfig of this.event.ticketConfig) {
        if (ticketConfig.id !== ticket.id) continue;
        for (const discount of ticketConfig.discounts) {
          if (discount?.id !== ticket.discount?.id) continue;
          foundDiscount = this.findDiscount(discount.id);
          discount.selectedQuantity--;
          if (foundDiscount?.availableTickets !== undefined) {
            foundDiscount.availableTickets++;
          }
        }
      }
    },
    async removeTicketPreviewSM({ ticket, index }) {
      this.ticketsSM.push(this.selectedTicketsSM[index]);
      if (this.selectedTicketsSM[index].seat !== '-') {
        const seat = this.selectedTicketsSM[index].seat;
        await seat.deselect(seat.selectedTicketType);
      }
      this.selectedTicketsSM.splice(index, 1);
    },
    async getOrganizer() {
      try {
        this.organizer = await this.$bamApi.account.getOrganizer({
          id: this.event?.organizerId,
          fields: ['tos', 'workspaceKey', 'branding']
        });

        if (this.organizer?.url && !this.organizer?.url.includes('://')) {
          this.organizer.url = '//' + this.organizer.url;
        }
      } catch (e) {
        this.$notifier.showMessage({
          content: errorMessage(e, this.$t('errors.fetchOrganizerInfo')),
          type: 'error'
        });
      }
    },
    async getVenue() {
      try {
        if (this.event.venueId) {
          this.event = {
            ...this.event,
            venue: await this.$bamApi.venue.getVenue({ id: this.event.venueId })
          };
        }
        if (this.isRecurring) {
          this.event.occurrence = await this.assignVenuesToOccurrences(
            this.event.occurrence
          );
        }
      } catch (e) {
        this.$notifier.showMessage({
          content: e?.response?.data?.message || this.$t('errors.fetchEvent'),
          type: 'error'
        });
      }
    },
    async getEvent() {
      try {
        const event = await this.fetchEvent();
        this.populateCart(event.type);

        if (event.type === this.eventTypes.SINGLE) {
          // ticket configs are formatted for cart
          event.ticketConfig = this.prepareTicketConfig(
            event.ticketConfig,
            event.type
          );
          // Single event means one occurrence
          event.occurrence = [
            {
              ...event,
              ...calculatePriceRange(event.ticketConfig)
            }
          ];
        } else {
          // If event has occurrences, map and format all ticket config
          event.occurrence = event.occurrence.map((occurrence) => {
            const tc = this.prepareTicketConfig(
              occurrence.ticketConfig,
              occurrence.type
            );
            return {
              ...occurrence,
              ...calculatePriceRange(tc),
              ticketConfig: occurrence.ticketConfig.filter((tc) => tc.visible)
            };
          });
          this.adjustRecurringEventDates(event);
        }

        this.event = event;
        this.event.timezone = getTimezoneFromName(
          event.startAt,
          event.timezoneName
        );

        if (this.event?.sector?.length > 0) {
          const sortedSectors = sortByDisplayOrder(this.event.sector);
          this.event.selectedSector = sortedSectors[0];
          this.preparedSectors = sortedSectors.map((s) => {
            return {
              id: s.id,
              label: s.name,
              displayOrder: s.displayOrder,
              selected: false
            };
          });
          this.preparedSectors[0].selected = true;
        }

        this.originalEventData = clone(this.event);
      } catch (e) {
        this.$notifier.showMessage({
          content: e?.response?.data?.message || this.$t('errors.fetchEvent'),
          type: 'error'
        });
      }
    },
    async fetchEvent() {
      const accessToken = this.$route.query.acc_token;
      await this.$bamApi.useOrganizer(this.tenant);

      let withQuery;
      if (this.$showTickets) {
        withQuery = {
          subcategory: true,
          sector: {
            ticket_config: {
              ticket_discount: true
            }
          },
          ticket_discount: true,
          ticket_config: {
            ticket_discount: true,
            depends_on: true
          },
          occurrence: {
            ticket_config: {
              ticket_discount: true,
              depends_on: true
            },
            timeslot: {
              ticket_config: true
            }
          },
          timeslot: {
            ticket_config: true
          },
          ticket_format: true
        };
      } else {
        withQuery = {
          subcategory: true
        };
      }

      if (accessToken) {
        return this.$bamApi.event.getPrivateEvent({
          id: this.eventId,
          access_token: accessToken,
          with: withQuery
        });
      }

      return this.$bamApi.event.getEvent({
        id: this.eventId,
        with: withQuery
      });
    },
    /** Redirects the user to the `event.redirectUrl`, if specified. Useful for pointing to new occurrences. */
    redirectIfNeeded(event) {
      if (isValidHttpUrl(event?.redirectUrl)) {
        window.location.href = event.redirectUrl;
      }
    },
    async getSecondaryTickets() {
      try {
        const offers = await this.$bamApi.orderbook.listOffers({
          event_id: this.eventId
        });
        offers.forEach((offer) => {
          const offerTicketConfig = this.event?.ticketConfig?.find((tc) => {
            return tc.id === offer.ticketConfigId;
          });
          if (offerTicketConfig) {
            const offerName = offerTicketConfig?.name;
            offer.ticketConfig = offerTicketConfig;
            this.ticketsSM.push({
              ...offer,
              name: offerName,
              // TODO FIX, for now:
              seat: '-',
              finalPrice: offer.price
            });
          }
        });
        this.offers = offers;
      } catch (e) {
        this.$notifier.showMessage({
          content: errorMessage(e, this.$t('errors.genericRequest')),
          type: 'error'
        });
      }
      this.loading = false;
    },
    /**
     * Parses and formats ticket config list for cart
     */
    prepareTicketConfig(ticketConfig) {
      const now = moment();
      return ticketConfig
        ?.sort((tA, tB) => {
          return tA?.id - tB?.id;
        })
        .map((ticketConfig) => {
          if (ticketConfig.startSaleAt) {
            ticketConfig.started = moment(ticketConfig.startSaleAt).isBefore(
              now
            );
          }
          if (ticketConfig.endSaleAt) {
            ticketConfig.ended = moment(ticketConfig.endSaleAt).isBefore(now);
          }

          const ticketConfigsInCart = this.selectedTickets.filter(
            (tc) => tc?.id === ticketConfig.id
          );

          const tcDiscounts = [
            { name: this.$t('buyTickets.noDiscount') },
            ...ticketConfig?.ticketDiscount
          ].map((discount) => {
            let finalPrice = ticketConfig.faceValue;
            if (discount?.id) {
              finalPrice = applyDiscount(discount, finalPrice);
            }

            const numberOfDiscountsApplied = ticketConfigsInCart.filter(
              (tc) => tc?.ticketDiscount[0]?.id === discount.id
            ).length;

            return {
              ...discount,
              finalPrice,
              fees: 0,
              selectedQuantity: numberOfDiscountsApplied
            };
          });

          const numberOfTicketConfigsInCart = ticketConfigsInCart.length;

          return {
            ...ticketConfig,
            amountOfTicketInCart: numberOfTicketConfigsInCart,
            availableTickets: Math.max(
              ticketConfig.availableTickets - numberOfTicketConfigsInCart,
              0
            ),
            discount: tcDiscounts[0],
            discounts: tcDiscounts
          };
        });
    },
    /**
     * Open a web socket to listen for wallet qr code scanning option to identify wallet
     *
     * @param channel
     * @param secret
     */
    openWebSocket(channel, secret) {
      try {
        const url = `wss://${this.tenant}.${this.$config.apiBaseUrl}/websocket/adhoc/${channel}/${secret}`;
        const client = new WebSocket(url);
        const thisPage = this;
        client.onmessage = (ev) => {
          const reader = new FileReader();
          reader.onloadend = function () {
            try {
              const response = JSON.parse(reader.result);
              thisPage.dialog = null;
              thisPage.$bamApi.authorize(new JwtCredentials(response));
              thisPage.createOrder();
            } catch (e) {
              this.$notifier.showMessage({
                content: this.$t('errors.publishEvent'),
                type: 'error'
              });
            }
          };
          reader.readAsText(ev.data);
        };
      } catch (e) {
        this.$notifier.showMessage({
          content: this.$t('errors.publishEvent'),
          type: 'error'
        });
      }
    },
    /**
     * Gets QR code data needed to continue with wallet login
     *
     */
    async getQrCode() {
      try {
        const secret = uuid();
        const response = await this.$services.account.identifyWallet(
          secret,
          this.tenant
        );
        if (response?.code) {
          this.qrcodeImage = response.code;
          this.dialog = null;
          this.openLogin();
          this.openWebSocket(response.channel, secret);
        } else {
          this.dialog = false;
          this.$notifier.showMessage({
            content: this.$t('errors.fetchEvent'),
            type: 'error'
          });
        }
      } catch (e) {
        this.dialog = false;
        if (e?.response?.status === 401) {
          this.$notifier.showMessage({
            content: this.$t('errors.editEventPermissions'),
            type: 'error'
          });
          this.$router.replace(this.localePath('/'));
        } else {
          this.$notifier.showMessage({
            content: this.$t('errors.fetchEvent'),
            type: 'error'
          });
        }
      }
    },
    checkUserType() {
      if (this.$auth.loggedIn) {
        this.fetchOwnedTickets();
        this.createOrder();
        // } else if (this.format === TICKET_FORMATS.SECURE) {this.getQrCode();
      } else {
        this.dialog = null;
        this.openLogin();
      }
    },
    async buyTickets() {
      if (this.currentTab === this.tabName.Tickets) {
        await this.createOrder();
      } else {
        await this.createSMOrder();
      }
    },
    async createSMOrder() {
      this.dialog = null;
      if (!this.$auth?.user?.enrollmentId) {
        this.$notifier.showMessage({
          content: this.$t('errors.purchaseNotEnrolled'),
          type: 'error'
        });
        return;
      }
      try {
        const offerData = {
          offers: this.selectedTicketsSM.map(
            (selectedTicket) => selectedTicket.id
          )
        };
        const res = await this.$bamApi.orderbook.createOrder(offerData);
        this.$store.commit('orders/addOrder', {
          orderData: res,
          market: 'secondary',
          eventId: this.event.id,
          orderId: res.order.id,
          orderTimeout: moment().add(30, 'minutes')
        });
        // if holders are required on sm tickets
        // if (this.event.kycLevelId !== KYC_LEVELS.NOT_REQUIRED) {
        //   // Needs to fill ticket holder info
        //   this.$router.push(
        //     this.localePath(
        //       `/${this.$route.params.tenant}/event/${this.$route.params.id}/holders`
        //     )
        //   );
        // } else {
        // KYC not required
        // add current query params to the url
        this.$router.push(
          this.localePath(`/${this.tenant}/event/${this.event.id}/confirm`)
        );
        // }
      } catch (err) {
        this.$notifier.showMessage({
          content: errorMessage(err, this.$t('errors.genericRequest')),
          type: 'error'
        });
      }
    },

    /**
     * Reduces tickets from the cart & returns reduced order items.
     *
     * Selected tickets in the PM cart can be of different types,
     * e.g. Regular tickets, VIP tickets, again Regular tickets etc.
     * When creating an order, this method reduces tickets of the
     * same type, so the Regular ticket configuration appears only
     * once in the order data, but with increased quantity (in this
     * case quantity = 2) and [if there are seats] with merged seat
     * ids.
     *
     * @function createOrderItems
     * @returns {Array} New array of reduced ticket configs.
     *
     */
    // TODO: refactor this whole helper function
    createOrderItems() {
      return this.selectedTickets.reduce((reducedTickets, ticket) => {
        let exist = false;
        reducedTickets.forEach((t) => {
          if (
            t.ticketConfigId === ticket.id &&
            t.ticketDiscount?.[0] === ticket.discount?.id &&
            t.sectorId === ticket.sector?.id &&
            t.timeslotId === ticket?.timeslotId &&
            t.kycLevelId === ticket.kycLevelId &&
            (!ticket.donationAmount || t.finalPrice === ticket.finalPrice)
          ) {
            exist = true;
            t.quantity++;
            if (ticket.seat) {
              t.selectedSeats.push(ticket.seat.id);
            }
          }
        });
        if (!exist) {
          const orderItem = {
            ticketConfigId: ticket.id,
            quantity: 1,
            ticketDiscount: ticket.discount ? [ticket.discount?.id] : undefined,
            sectorId: ticket.sector ? ticket.sector.id : undefined,
            timeslotId: ticket?.timeslotId,
            kycLevelId: ticket?.kycLevelId,
            occurrenceId: ticket?.occurrenceId,
            occurrenceName: ticket?.occurrenceName,
            occurrenceStartAt: ticket?.occurrenceStartAt,
            occurrenceEndAt: ticket?.occurrenceEndAt,
            seatId: ticket?.seat?.id
          };
          if (ticket.seat) {
            orderItem.selectedSeats = [ticket.seat.id];
          }
          if (ticket.donationAmount) {
            orderItem.selectedPrice = ticket.donationAmount;
          }
          reducedTickets.push(orderItem);
        }
        return reducedTickets;
      }, []);
    },

    /**
     * Creates order data for POST API call.
     *
     * If the user is enrolled or a guest, the order data is created
     * with the usage of the createOrderItems function.
     * The order data (as a result from the API call), the type of
     * the market [primary or secondary], order id and order timeout
     * are persisted with vuex in the local storage.
     * If the KYC level is set to 'no KYC', the user is redirected to
     * the confirm page (to finish the transaction), else the user is
     * redirected to the holders page (to enter holder data).
     *
     * @function createOrder
     */
    async createOrder() {
      this.$store.commit('app/setLoading', true);
      try {
        this.dialog = null;
        if (!this.$auth?.user?.enrollmentId && !this.$auth.user?.guestId) {
          this.$notifier.showMessage({
            content: this.$t('errors.purchaseNotEnrolled'),
            type: 'error'
          });
          return;
        }

        const createOrderData = {
          orderItem: this.createOrderItems(),
          format: this.format,
          holdToken: this.seatingChart?.holdToken
        };
        if (this.discountCode) {
          createOrderData.discountCode = this.discountCode;
        }
        const res = await this.$bamApi.order.createOrder(createOrderData);

        this.$fb.track('InitiateCheckout', toInitiateCheckoutEvent(res));
        // order data to be persisted in vuex local store
        // order data from api call is merged with previous order data from store so additional details can be displayed on the next page
        const storeOrderData = {
          ...res,
          orderItem: res.orderItem.map((oi) => {
            return {
              ...oi,
              ticket: oi.ticket.map((ticket) => {
                const ticketInOrderCreationPayload =
                  createOrderData.orderItem.find(
                    (oi) => oi.ticketConfigId === ticket.ticketConfig.id
                  );
                return {
                  ...ticket,
                  occurrenceId: ticketInOrderCreationPayload?.occurrenceId,
                  occurrenceName: ticketInOrderCreationPayload?.occurrenceName,
                  occurrenceStartAt:
                    ticketInOrderCreationPayload?.occurrenceStartAt,
                  occurrenceEndAt: ticketInOrderCreationPayload?.occurrenceEndAt
                };
              })
            };
          })
        };
        // Order is persisted with vuex in local storage
        this.$store.commit('orders/addOrder', {
          orderData: storeOrderData,
          market: 'primary',
          eventId: this.event.id,
          orderId: res.id,
          orderTimeout: moment().add(30, 'minutes')
        });
        const query = this.$route.query;
        if (
          createOrderData.orderItem.some(
            (oi) => oi.kycLevelId !== KYC_LEVELS.NOT_REQUIRED
          )
        ) {
          // Needs to fill ticket holder info
          this.$router.push({
            path: this.localePath(
              `/${this.tenant}/event/${this.event.id}/holders`
            ),
            query
          });
        } else {
          // KYC not required
          this.$router.push({
            path: this.localePath(
              `/${this.tenant}/event/${this.event.id}/confirm`
            ),
            query
          });
        }
      } catch (err) {
        this.$notifier.showMessage({
          content: errorMessage(err, this.$t('errors.genericRequest')),
          type: 'error'
        });
      } finally {
        this.$store.commit('app/setLoading', false);
      }
    },
    async fetchOwnedTickets() {
      this.ownedTickets = await this.$bamApi.ticket.getTickets({
        with: {
          ticket_config: {
            depends_on: true
          }
        }
      });
    }
  }
};
</script>
<style lang="scss">
@import '@/assets/_scss/_utils/variables.scss';
@import '@/assets/_scss/_utils/mixins.scss';

.event__banner {
  display: block;
  position: relative;
  width: 100%;
  height: 100%;
}
.no-padding {
  padding: 0 !important;
}
.v-data-table__empty-wrapper > td {
  color: var(--v-backgroundPrimary-base) !important;
}
h1 {
  margin-bottom: 0.5rem;
}
.event-detail {
  margin-top: 1.5rem;
}
.event-details-screen {
  .v-btn.v-size--default {
    font-size: 0.625rem;
    line-height: 160%;
  }
  .v-btn:not(.v-btn--round).v-size--default {
    padding: 0 24px;
  }
  .v-btn.v-size--large {
    height: 4.5rem !important;
    font-family: inherit;
    font-style: normal !important;
    font-weight: bold;
    letter-spacing: unset;
    font-size: 1.5rem;
    line-height: 1.8125rem;
    text-transform: none;
    color: var(--v-primary-base);
  }
  .theme--dark.v-btn:not(.v-btn--flat):not(.v-btn--text):not(
      .v-btn--outlined
    ).success {
    color: var(--v-primary-base);
  }
  .theme--dark.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(
      .v-btn--outlined
    ) {
    background-color: transparent !important;
    border-style: solid;
    border-color: var(--v-primary-lighten1);
    border-width: 2px;
    color: var(--v-primary-lighten1) !important;
  }
}

.event-container {
  min-height: 40vh;
  @media (max-width: 600px) {
    min-height: 60vh;
    @media (min-height: 600px) {
      min-height: 70vh;
    }
  }
}
.v-dialog.format-dialog {
  margin: 0 !important;
  width: 45.625rem;

  // 500px is around the height of mobile devices in landscape mode, so this will affect everything above that
  @media (min-height: 500px) {
    height: 50rem;
  }
}
.qrcode-col {
  width: 18.5rem;
}
.qrcode-image-container {
  width: 100%;
  height: unset;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
}
.qrcode-image {
  height: 18.5rem;
  width: 18.5rem;
  border-radius: 1rem;
  @media (max-width: 600px) {
    margin-top: 1rem;
  }
}
.play-button-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1rem;
}
.dialog-card {
  background-color: var(--v-backgroundGray-lighten2) !important;
  padding-top: 1rem;
  padding-bottom: 1rem;
  padding-left: 7.25rem;
  padding-right: 7.25rem;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  align-items: center;
  .v-window {
    flex-grow: 1;
    max-width: 100vw;
  }
  @media (max-width: 600px) {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  .format-buttons-container {
    margin-top: 2rem;
    margin-bottom: 2rem;
    @media (max-width: 600px) {
      margin: 1rem;
    }
  }
  .format-button {
    margin-bottom: 1.5rem;
    border-width: 1.5px;
    border-style: solid;
    border-color: var(--v-textPrimary-base) !important;
    border-radius: 0.75rem;
    width: 12.5rem;
    height: 12.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    @media (max-width: 600px) {
      width: 6.5em;
      height: 6.5rem;
    }
  }
  .center {
    margin-left: auto;
    margin-right: auto;
  }
  .format-button.active {
    background-color: var(--v-backgroundPrimary-base);
    border: none;
  }
  .format-button.disabled {
    border-style: none;
  }
  .format-button.disabled div.v-image__image {
    background-blend-mode: soft-light;
  }
  h1 {
    margin-bottom: 0;
    font-size: 2.375rem;
    line-height: 2.875rem;
    @media (max-width: 600px) {
      margin-top: 3rem;
      font-size: 1.275rem;
      line-height: 1.675rem;
    }
  }
  p {
    color: var(--v-textPrimary-base);
    margin-bottom: 0.375rem;
    @media (max-width: 600px) {
      margin-bottom: 0;
      font-size: 0.875rem;
    }
  }
}
.v-btn.confirm-button {
  font-size: 1rem;
  line-height: 1.25rem;
  color: var(--v-primary-base);
}
.theme--dark.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(
    .v-btn--outlined
  ).confirm-button {
  border-color: var(--v-primary-lighten3);
  color: var(--v-primary-lighten3) !important;
}
.bullet.active {
  background-color: var(--v-backgroundPrimary-base);
}
.bullet {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border-color: var(--v-backgroundPrimary-base);
  border-style: solid;
  border-width: 1px;
  margin-right: 4px;
  margin-left: 4px;
}
.chart-container {
  position: relative;
}
.chart-overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #18222edd;
}
.sector-map-btn {
  height: 2rem;
}
.center-text {
  text-align: center;
}
.v-data-table td {
  font-size: 1rem;
  border-bottom: none !important;
}
.theme--light.v-data-table .v-data-footer {
  border-top: none;
  color: var(--v-textPrimary-lighten5);
  background-color: var(--v-backgroundPrimary-lighten5);
}

.theme--light.v-data-table {
  border-top: none;
  background-color: var(--v-backgroundGray-lighten2);
}
.header-styling {
  font-weight: 700 !important;
  font-size: 0.75rem !important;
  color: var(--v-textPrimary-lighten2) !important;
  border-bottom: none !important;
}
.item-styling {
  color: var(--v-textPrimary-base);
  font-weight: 400 !important;
  word-break: break-word;
}
.primary-text-color {
  color: var(--v-textPrimary-base);
}

.slider-background {
  .v-slide-group__wrapper {
    background-color: var(--v-backgroundGray-lighten2);
  }
}
.format-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: center;
}
.button-container {
  width: 100%;
}

/* Styles for cart footer */
.cart-footer {
  position: sticky;
  bottom: 0;
  width: 100%;
  padding: 16px 24px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  border-top: 1px solid var(--v-borderPrimary-lighten4);
  background: var(--v-backgroundGray-lighten3);
  box-shadow: 0px -2.5px 8px 0px rgba(0, 0, 0, 0.15);

  &__button {
    padding: 12px 16px;
    width: 117px;
    justify-content: center;
  }

  &__details {
    display: flex;
    flex-direction: column;
    gap: 5px;
    div {
      color: var(--v-textPrimary-base);
    }
  }
}

/* Styles for mobile cart */
.mobile-cart {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  /* Add padding at the top to leave space for the header */
  padding-top: $header-height; // Replace with actual header height
}

/* Slide animation styles */
.slide-enter-active,
.slide-leave-active {
  transition: all 0.5s ease;
}

.slide-enter-from,
.slide-leave-to {
  transform: translateY(100%);
}

.slide-enter-to,
.slide-leave-from {
  transform: translateY(0);
}

.donation-dialog {
  &__content {
    display: flex;
    flex-direction: column;
    padding: 0 16px;
    width: 700px;

    &--text {
      margin-bottom: 32px;
      &--bold {
        color: var(--v-textPrimary-base) !important;
      }

      // Some predefined classes come with colors, so we need to override them
      div,
      span {
        color: var(--v-textPrimary-lighten1) !important;
      }
    }

    &--error {
      padding-top: 4px;
      min-height: 20px;
      color: var(--v-textHighlightError-base) !important;
    }

    .p-inputnumber {
      width: 100%;
    }
  }
}

.mobile-dialog {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 100;
  padding: 0 24px;
  padding-top: 32px;
  background-color: var(--v-backgroundGray-lighten2);

  &__header {
    margin-bottom: 16px;
    color: var(--v-textPrimary-base);
  }

  &__content {
    margin-bottom: 24px;
    color: var(--v-textPrimary-lighten1) !important;

    &--text {
      color: var(--v-textPrimary-base);
    }

    &--error {
      padding-top: 4px;
      color: var(--v-textHighlightError-base) !important;
    }
  }
  .p-inputnumber {
    width: 100%;
  }
  &__footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    border-top: 1px solid var(--v-borderPrimary-lighten4);
    display: flex;
    justify-content: space-around;
    padding: 24px;
    gap: 24px;

    .p-button {
      flex: 1;
    }
  }
}

.preferred-date {
  @include respond-below(smallDevice) {
    span.p-float-label {
      flex: 1;
    }
  }
}

.no-occurrences-message {
  text-align: center;
  padding: 2rem;
}
</style>
